import(/* webpackMode: "eager", webpackExports: ["NotFoundPage"] */ "/Users/k1dalica/Desktop/Projects/infiteq.io/components/ui/not-found-page-2.tsx");
